
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/day-pass",
      function () {
        return require("private-next-pages/booking/day-pass/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking/day-pass"])
      });
    }
  